module.exports = __webpack_public_path__ + "img/fondo-banner-principal.f20e6925.png";